import React, { Component } from 'react';
import TermsConditions from '../../client/shared-ui/t&c';

class TermAndConditionsPage extends Component {
  render () {
    return (
      <TermsConditions />
    );
  }
}

export default TermAndConditionsPage;